import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './newStyle.css';
import './index.css';
import './pages/scheduler/scheduler.css';
import './pages/affiliate/affiliate.css';
import './styles/sidebar-improvements.css';
import './styles/profile-settings.css';
import './styles/dashboard.css';
import './styles/admin-table.css';

import Routes from './pages/MainRoutes'
import 'react-loading-skeleton/dist/skeleton.css'
import { useStore } from './zustand/store';

function App(props) {
let store = useStore(state => state)

    return (
        <div  className={`App ${store.resMenuToggle ? 'opensidebar' : 'closesidebar'}`}>
            <Routes />
        </div>
    );
}

export default App;
